<template>
  <b-row>
    <b-col cols="10" offset="1">
      <b-list-group
        v-for="(item, index) in buildingOwnerLotsData.parts"
        :key="item.buildingLotId + index"
      >
        <b-list-group-item class="d-flex align-items-center justify-content-around my-2">
          <span>
            Lot :
            <b-badge variant="primary" class="bo-lot" pill>
              {{ item.lot }}
            </b-badge>
          </span>
          <span>
            Tantième :
            <b-badge variant="danger" class="bo-parts" pill>
              {{ item.parts }}
            </b-badge>
          </span>
          <b-checkbox
            class="mb-2"
            :checked="checkIfLotIsDeparted(item.buildingLotId)"
            @change="updateBuildingLotsToSale($event, item.buildingLotId)"
          ></b-checkbox>
        </b-list-group-item>
      </b-list-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    buildingLotsToSale: {
      type: Array,
      default: () => {
        return [];
      },
    },
    buildingOwnerLotsData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    updateBuildingLotsToSale(checked, id) {
      this.$emit("updateBuildingLotsToSale", checked, id);
    },
    checkIfLotIsDeparted(id) {
      let find = this.buildingLotsToSale.find(element => element == id);
      if (find) {
        return true;
      }
    },
  },
};
</script>
